import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation("common");

  return (
    <footer id="contact" className="bg-background-50 px-4 md:px-6 lg:px-8 pb-6 pt-6">
      <div className="bg-foreground-950 rounded-2xl md:rounded-3xl overflow-hidden">
        <div className="px-6 md:px-12 lg:px-16 py-12 md:py-16 lg:py-20">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8 lg:gap-12">
            <div className="md:col-span-5">
              <h3 className="font-heading text-3xl md:text-4xl lg:text-5xl font-normal text-white/90 leading-tight mb-4">
                {t("footer.tagline")}
              </h3>
              <p className="text-white/50 text-sm md:text-base leading-relaxed mb-8 max-w-sm">
                {t("footer.description")}
              </p>
              <form
                className="flex flex-col sm:flex-row gap-3 max-w-sm"
                onSubmit={(e) => {
                  e.preventDefault();
                  const form = e.currentTarget;
                  const message = (form.elements.namedItem("message") as HTMLInputElement)?.value;
                  if (message) {
                    const encoded = encodeURIComponent(message);
                    window.open(`https://wa.me/201099289280?text=${encoded}`, "_blank", "noopener,noreferrer");
                  }
                }}
              >
                <input
                  type="text"
                  name="message"
                  placeholder={t("footer.newsletter.placeholder")}
                  required
                  className="flex-1 bg-transparent border-b border-white/30 text-white text-sm py-3 px-1 outline-none placeholder:text-white/40 focus:border-white/60 transition-colors"
                />
                <button
                  type="submit"
                  className="bg-white text-foreground-950 text-sm font-medium px-6 py-3 rounded-full hover:bg-white/90 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                >
                  {t("footer.newsletter.subscribe")}
                  <i className="ri-arrow-right-line text-sm"></i>
                </button>
              </form>
            </div>

            <div className="md:col-span-3 md:col-start-7">
              <h4 className="text-white/70 text-xs font-medium uppercase tracking-wider mb-5">
                {t("footer.navigation")}
              </h4>
              <ul className="space-y-3">
                {[
                  { label: t("nav.home"), to: "/" },
                  { label: t("nav.advantages"), to: "/#advantages" },
                  { label: t("nav.industries"), to: "/#industries" },
                  { label: t("nav.pricing"), to: "/plans" },
                  { label: t("nav.faq"), to: "/#faq" },
                  { label: t("nav.testimonials"), to: "/#testimonials" },
                  { label: t("nav.dashboard"), to: "/dashboard" },
                ].map((item) => (
                  <li key={item.label}>
                    <Link
                      to={item.to}
                      className="text-white/60 text-sm hover:text-white/90 transition-colors underline underline-offset-4"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="md:col-span-3">
              <h4 className="text-white/70 text-xs font-medium uppercase tracking-wider mb-5">
                {t("footer.contact")}
              </h4>
              <div className="space-y-3 text-sm text-white/60">
                <p className="text-white/90 font-medium">{t("footer.phone")}</p>
                <p>{t("footer.email")}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 px-6 md:px-12 lg:px-16 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4 text-sm text-white/50">
            <a href="https://www.facebook.com/debugsoftware/" target="_blank" rel="nofollow noopener noreferrer" className="hover:text-white/80 transition-colors underline underline-offset-2">
              Facebook
            </a>
            <a href="https://www.linkedin.com/company/debug-software" target="_blank" rel="nofollow noopener noreferrer" className="hover:text-white/80 transition-colors underline underline-offset-2">
              LinkedIn
            </a>
            <a href="https://www.instagram.com/debugsoftware1/" target="_blank" rel="nofollow noopener noreferrer" className="hover:text-white/80 transition-colors underline underline-offset-2">
              Instagram
            </a>
          </div>
          <p className="text-sm text-white/40 text-center">
            {t("footer.copyright")}
          </p>
          <div className="flex items-center gap-4 text-sm text-white/50">
            <Link to="/privacy" className="hover:text-white/80 transition-colors underline underline-offset-2">
              {t("footer.privacy")}
            </Link>
            <Link to="/terms" className="hover:text-white/80 transition-colors underline underline-offset-2">
              {t("footer.terms")}
            </Link>
            <a
              href="https://debugin.com/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-white/40 hover:text-white/70 transition-colors underline underline-offset-2"
            >
              Powered by Debug
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}